














































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import MultilineInput from 'vuecomponents/multiline_input.vue'
import { IntlMixin } from 'vuemixins/intl_mixin'
import attachmentCaptionForDisplay from 'surface/attachment_caption_for_display'

@Component({ components: { MultilineInput } })
export default class BeethovenAttachmentCaption extends Mixins(IntlMixin) {
  $refs!: {
    input: MultilineInput
  }
  @Prop() caption!: string
  @Prop() attachmentTitle!: string
  @Prop({ default: true }) canEditInline!: boolean
  @Prop({ default: true }) xPlaceholder!: boolean
  /**
   * How the component should decide to show dark mode: Using browser or with custom isDark prop
   */
  @Prop({ default: 'browser' }) darkThemeType!: 'browser' | 'custom'
  @Prop({ default: 'browser' }) isDark!: false

  editing = false
  focusingOnLoad = false

  public focusOnLoad() {
    this.focusingOnLoad = true
  }

  @Watch('canEditInline')
  handleWhenCaptionEditable(canEditInline: boolean) {
    this.$nextTick(() => {
      if (canEditInline && this.focusingOnLoad && this.$refs.input) {
        this.$refs.input.focus()
      }
    })
  }

  get captionBeingDisplayed(): string {
    if (this.editing) {
      return attachmentCaptionForDisplay({
        postAttachmentCaption: this.caption,
        defaultCaption: '',
      })
    }
    return attachmentCaptionForDisplay({
      postAttachmentCaption: this.caption,
      defaultCaption: this.attachmentTitle,
    })
  }

  onChange(newValue: string) {
    this.$emit('change', newValue)
  }

  onEditStart() {
    this.$emit('edit-start')
    if (!this.canEditInline) return
    this.editing = true
  }

  onEditEnd() {
    this.editing = false
  }

  mounted() {
    this.$nextTick(() => {
      if (this.canEditInline && this.focusingOnLoad && this.$refs.input) {
        this.$refs.input.focus()
      }
    })
  }
}
